import type { CanonicalKey } from "./SoilKeys";
import { SOIL_KEYS } from "./SoilKeys";
// soilRasters.ts
const files = [
  "SC11_pH_2025.tif",
  "SC47_C_2025.tif",
  "CC9_N_2025.tif",
  "SC35_K_ppm_2025.tif",
  "SC30_Bulkdensity_2025.tif",
  "SC35_C_2025.tif",
  "CC65_K_ppm_2025.tif",
  "SC17_Bulkdensity_2025.tif",
  "SC41_N_2025.tif",
  "CC23_P_2025.tif",
  "SC47_Bulkdensity_2025.tif",
  "CC65_N_2025.tif",
  "CC6_Bulkdensity_2025.tif",
  "SC41_P_2025.tif",
  "SC17_CEC_meq_2025.tif",
  "SC03_pH_2025.tif",
  "SC03_P_2025.tif",
  "SC30_CEC_meq_2025.tif",
  "SC30_C_2025.tif",
  "CC9_P_2025.tif",
  "CC60_Bulkdensity_2025.tif",
  "SC35_CEC_meq_2025.tif",
  "SC11_K_ppm_2025.tif",
  "SC17_P_2025.tif",
  "CC13_P_2025.tif",
  "SC03_N_2025.tif",
  "SC48_CEC_meq_2025.tif",
  "SC47_pH_2025.tif",
  "SC28_pH_2025.tif",
  "SC35_pH_2025.tif",
  "CC60_C_2025.tif",
  "SC35_Bulkdensity_2025.tif",
  "CC13_Soil_Texture_2025.tif",
  "SC35_P_2025.tif",
  "CC13_CEC_meq_2025.tif",
  "SC50_pH_2025.tif",
  "SC28_Bulkdensity_2025.tif",
  "CC63_pH_2025.tif",
  "SC30_pH_2025.tif",
  "SC17_N_2025.tif",
  "CC63_C_2025.tif",
  "CC60_pH_2025.tif",
  "SC28_P_2025.tif",
  "CC9_C_2025.tif",
  "SC48_pH_2025.tif",
  "SC41_CEC_meq_2025.tif",
  "SC48_Bulkdensity_2025.tif",
  "SC41_Bulkdensity_2025.tif",
  "CC23_C_2025.tif",
  "SC48_N_2025.tif",
  "CC65_pH_2025.tif",
  "SC03_CEC_meq_2025.tif",
  "SC03_C_2025.tif",
  "CC65_Bulkdensity_2025.tif",
  "SC28_N_2025.tif",
  "CC23_CEC_meq_2025.tif",
  "SC48_K_ppm_2025.tif",
  "SC41_pH_2025.tif",
  "CC13_K_ppm_2025.tif",
  "CC63_CEC_meq_2025.tif",
  "CC6_C_2025.tif",
  "SC50_C_2025.tif",
  "CC13_pH_2025.tif",
  "SC11_Bulkdensity_2025.tif",
  "CC6_pH_2025.tif",
  "CC60_K_ppm_2025.tif",
  "CC63_Bulkdensity_2025.tif",
  "CC6_P_2025.tif",
  "SC17_pH_2025.tif",
  "CC23_N_2025.tif",
  "SC28_CEC_meq_2025.tif",
  "CC13_C_2025.tif",
  "SC28_C_2025.tif",
  "CC6_N_2025.tif",
  "SC48_C_2025.tif",
  "SC11_P_2025.tif",
  "SC30_P_2025.tif",
  "CC65_C_2025.tif",
  "CC63_P_2025.tif",
  "CC60_Soil_Texture_2025.tif",
  "SC50_CEC_meq_2025.tif",
  "CC9_K_ppm_2025.tif",
  "CC60_P_2025.tif",
  "SC11_C_2025.tif",
  "SC50_P_2025.tif",
  "CC23_Bulkdensity_2025.tif",
  "SC48_P_2025.tif",
  "CC13_Bulkdensity_2025.tif",
  "CC23_Soil_Texture_2025.tif",
  "CC60_N_2025.tif",
  "CC63_Soil_Texture_2025.tif",
  "CC60_CEC_meq_2025.tif",
  "CC13_N_2025.tif",
  "SC17_K_ppm_2025.tif",
  "SC47_P_2025.tif",
  "SC35_N_2025.tif",
  "SC03_K_ppm_2025.tif",
  "SC50_Bulkdensity_2025.tif",
  "CC63_K_ppm_2025.tif",
  "SC30_K_ppm_2025.tif",
  "SC41_C_2025.tif",
  "SC17_C_2025.tif",
  "CC65_P_2025.tif",
  "SC47_CEC_meq_2025.tif",
  "SC41_K_ppm_2025.tif",
  "SC47_N_2025.tif",
  "CC9_Bulkdensity_2025.tif",
  "SC11_CEC_meq_2025.tif",
  "CC9_CEC_meq_2025.tif",
  "CC6_CEC_meq_2025.tif",
  "CC9_pH_2025.tif",
  "CC23_K_ppm_2025.tif",
  "SC11_N_2025.tif",
  "CC63_N_2025.tif",
  "SC30_N_2025.tif",
  "CC6_K_ppm_2025.tif",
  "SC03_Bulkdensity_2025.tif",
  "SC28_K_ppm_2025.tif",
  "SC47_K_ppm_2025.tif",
  "SC50_N_2025.tif",
  "SC50_K_ppm_2025.tif",
  "CC65_CEC_meq_2025.tif",
  "CC6_Soil_Texture_2025.tif",
  "CC23_pH_2025.tif",
  "SC28_Soil_Texture_2025.tif",
  "SC35_Soil_Texture_2025.tif",
  "SC30_Soil_Texture_2025.tif",
  "SC17_Soil_Texture_2025.tif",
  "SC50_Soil_Texture_2025.tif",
  "SC41_Soil_Texture_2025.tif",
  "SC47_Soil_Texture_2025.tif",
  "SC48_Soil_Texture_2025.tif",
  "CC65_Soil_Texture_2025.tif",
  "SC03_Soil_Texture_2025.tif",
  "SC11_Soil_Texture_2025.tif",
  "CC9_Soil_Texture_2025.tif",
];

type YearMap = Record<string, string>; // e.g. { "2025": "rasters/SC41_pH_2025.tif" }
type SoilRastersType = Record<CanonicalKey, Record<string, string | YearMap>>;

export const SoilRasters: SoilRastersType = Object.fromEntries(
  SOIL_KEYS.map(k => [k, {}])
) as SoilRastersType;

function normalizeProperty(raw: string): CanonicalKey | null {
  switch (raw) {
    case "pH": return "pH";
    case "C": return "C";
    case "N": return "N";
    case "P": return "P";
    case "K_ppm": case "K": return "K";
    case "CEC_meq": case "CEC": return "CEC";
    case "Bulkdensity": case "BulkDensity": case "Bulk_Density": return "Bulkdensity";
    case "Soil_Texture": case "SoilTexture": return "Soil_Texture";
    default: return null;
  }
}

// Accept: ALL_pH.tif, ALL_pH_2025.tif, SC41_pH.tif, SC41_pH_2025.tif, CC13_K_ppm_2026.tif
function parseFilename(file: string) {
  const m = /^(ALL|SC\d+|CC\d+)_([A-Za-z]+(?:_[A-Za-z]+)?)(?:_(20\d{2}))?\.tif$/i.exec(file);
  if (!m) return null;
  const [, sub, rawProp, yr] = m;
  const prop = normalizeProperty(rawProp);
  if (!prop) return null;
  return { sub: sub.toUpperCase(), prop, year: yr || null, path: `rasters/${file}` };
}

files.forEach(f => {
  const p = parseFilename(f);
  if (!p) return;
  const current = SoilRasters[p.prop][p.sub];
  if (p.year) {
    const obj: YearMap = typeof current === "string" ? {} : (current || {});
    obj[p.year] = p.path;
    SoilRasters[p.prop][p.sub] = obj;
  } else {
    SoilRasters[p.prop][p.sub] = p.path;
  }
});